import React from 'react'
import Ricette from './Ricette'

export default function RicetteContainer() {
    return (
        <div>
            <Ricette id={"1"} />
            <Ricette id={"2"} />
            <Ricette id={"3"} />
            <Ricette id={"4"} />
            <Ricette id={"5"} />
        </div>
    )
}

